exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-button-with-tooltip__popout__twyng{width:325px;padding-bottom:25px}.account-button-with-tooltip__popout-inner__1AfgD{padding:0;background-color:#fff}.account-button-with-tooltip__popout-triangle__h8G5H{background-color:#fff;margin-bottom:25px}.account-button-with-tooltip__account-info-button__3wRVM{font-size:28px;background:none;color:-wix-colors-buttonsAndLinksColor-80}.account-button-with-tooltip__account-info-button__3wRVM:hover{background:none;color:-wix-colors-buttonsAndLinksColor}", ""]);

// exports
exports.locals = {
	"popout": "account-button-with-tooltip__popout__twyng",
	"popout-inner": "account-button-with-tooltip__popout-inner__1AfgD",
	"popoutInner": "account-button-with-tooltip__popout-inner__1AfgD",
	"popout-triangle": "account-button-with-tooltip__popout-triangle__h8G5H",
	"popoutTriangle": "account-button-with-tooltip__popout-triangle__h8G5H",
	"account-info-button": "account-button-with-tooltip__account-info-button__3wRVM",
	"accountInfoButton": "account-button-with-tooltip__account-info-button__3wRVM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/account/account-button/account-info-button-with-tooltip/account-button-with-tooltip.styl
// module id = 2902
// module chunks = 1